module.exports = __webpack_public_path__ + "static/img/dba-lean-course.97853a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/dba-lean-course.png
// module id = j7jj
// module chunks = 2